import React from "react";
import { Page } from "@sscs/ui";
import styles from "./cookiePolicy.module.scss";

export type CookiePolicyProps = {
  analyticsUsed: boolean;
  gtmUsed: boolean;
};

export default function CookiePolicy({
  analyticsUsed,
  gtmUsed,
}: CookiePolicyProps): React.JSX.Element {
  return (
    <Page.Root>
      <Page.Header title="Cookie policy" />
      <Page.Body>
        <article className={styles.document}>
          <p>
            We use cookies and similar technologies to track and optimize
            website performance, improve website pages and optimize graphics and
            content on the website. In those jurisdictions that require it, we
            allow the data subject to give explicit permission or to deny the
            use of certain categories of cookies.
          </p>
          <h2>What is a cookie?</h2>
          <p>
            A “cookie” is a small text file that a web server stores in browser
            software. A browser sends cookies to a server when the browser makes
            a connection to the server (for example, when requesting a web page
            from the same domain that created the cookie). The purpose of
            cookies is to remember the browser over time and distinguish one
            browser instance (or user) from all others. Some cookies and other
            technologies may serve to track Personal Data previously entered by
            a web user on our site. Most browsers allow you to control cookies,
            including whether or not to accept them, and how to remove them.
            Cookies can remember login information, preferences, and similar
            information.
          </p>
          <p>
            Cookies, as well as other tracking technologies such as HTML5 local
            storage, Local Shared Objects (such as “Flash” cookies), and similar
            mechanisms may record information such as a unique identifier,
            information you enter in a form, IP address, and other categories of
            data.
          </p>
          <p>
            We also use web beacons or “pixels,” and in certain circumstances
            may collect IP address, screen resolution, browser software and
            operating system types; clickstream patterns; dates and times that
            our site is accessed, and other categories of data.
          </p>
          <p>
            If you want to block the use and saving of cookies from the Site
            onto your computer&apos;s hard drive, you should take the necessary
            steps within your web browser&apos;s settings to block all cookies
            from the Site and its external serving vendors. Please note that if
            you choose to erase or block your cookies, certain parts of our Site
            may not function correctly. For information on how to disable
            cookies, refer to your browser&apos;s documentation.
          </p>
          <h2>Cookies we use</h2>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Cookie type</th>
                <th>Usage</th>
                <th>Example</th>
              </tr>
            </thead>
            <tbody>
              {analyticsUsed && (
                <tr>
                  <td>Analytics</td>
                  <td>These cookies are used for analysis of Site usage.</td>
                  <td>Google Analytics, HotJar{gtmUsed ? ", PostHog" : ""}</td>
                </tr>
              )}
              <tr>
                <td>Functional</td>
                <td>
                  These cookies provide improvements to the usability and
                  performance of the website and support for various features.
                </td>
                <td>sessionid, csrftoken</td>
              </tr>
            </tbody>
          </table>
        </article>
      </Page.Body>
    </Page.Root>
  );
}
